import React from 'react';
import './Services.scss';

import iconCart from '../../assets/img/icon-cart.png';
import iconDelivery from '../../assets/img/icon-delivery.png';
import iconCatalogo from '../../assets/img/icon-catalogo.png';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <section className="services">
      <div className="container">
        <div className="row">

          <div className="col-md-4 services__wrapper">
            <div className="services__card">
              <div className="services__icon">
                <img className="img-fluid" src={iconCart} alt="Envios" />
              </div>
              <h3 className="services__title">
                Tenemos para ofrecerte una amplia variedad de productos
              </h3>
              <h3 className="services__content">
                Simplemente envianos el carrito de compras con el/los producto/s seleccionado/s y nos contactaremos para coordinar la entrega en tu domicilio.
              </h3>
            </div>
          </div>

          <div className="col-md-4 services__wrapper">
            <div className="services__card">
              <div className="services__icon">
                <img src={iconDelivery} alt="Envios" />
              </div>
              <h3 className="services__title">
                Envíos<br />a domicilio
              </h3>
              <p className="services__content">
                Hacé tu pedido y te contactaremos a la brevedad para coordinar la entrega.
              </p>
              {/* <Link to="/tienda/ofertas/" className="btn btn-success w-100">
                VER OFERTAS DESTACADAS &gt;
              </Link> */}
            </div>
          </div>


          <div className="col-md-4 services__wrapper">
            <div className="services__card">
              <div className="services__icon">
                <img src={iconCatalogo} alt="Envios" />
              </div>
              <h3 className="services__title">
                Te invitamos a ver Nuestro Catálogo Online
              </h3>
              <p className="services__content">
                Si querés hacernos una consulta previa contactamos por Messenger, Facebook o Whatsapp y te responderemos a la brevedad.
              </p>
              {/* <a href="/contacto" className="btn btn-success w-100">
                CONSULTAR ENVÍO &gt;
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
